import { memo } from 'react';
import { RowIdType } from '../../../../../../types';
import { ImageHighlighterWrapper } from '../../../../../imageHighlighter/imageHighlighter';
import { Checkbox } from 'semantic-ui-react';
import { useChangeRowMetadata, useIsRowImportCandidate } from '../../../../../../stores/metadataStore';
import { useRowBoundingBox } from '../../../../../../stores/boundingBoxesStore';
import { HIGHLIGHTER_VARIANT } from '../../../../../../constants/generalConstants';

type RowInclusionControlPropsType = {
    rowId: RowIdType;
};
const RowInclusionControl = memo(function RowInclusionControl({ rowId }: RowInclusionControlPropsType) {
    const isImportCandidate = useIsRowImportCandidate(rowId);
    const changeRowMetadata = useChangeRowMetadata();

    const boundingBox = useRowBoundingBox(rowId);

    return (
        <ImageHighlighterWrapper coordinates={[{ ...boundingBox, variant: HIGHLIGHTER_VARIANT.PRIMARY }]}>
            <Checkbox
                checked={isImportCandidate}
                onChange={() => {
                    changeRowMetadata(rowId, {
                        importCandidate: !isImportCandidate,
                    });
                }}
            />
        </ImageHighlighterWrapper>
    );
});

export default RowInclusionControl;
